<template>
  <div>
    <router-view/>
  </div>
</template>

<script>
  export default {
    name: 'CityHallMapper'
  }
</script>

<style scoped>

</style>